<template>
    <div class="client-stats">
        <div class="browser">
            <div class="browser-left">
                <g-field
                    v-model="client"
                    :app="app"
                    table="clients"
                    column-search="alias"
                    name="client"
                    placeholder="Cliente"
                    ret-label="alias"
                    :clean="true"
                    @input="changeClient"
                />
                <year-select v-model="selectedYears" :minYear="2022" :maxSelection="2" placeholder="Selecionar temporada" />
            </div>
            <div class="browser-right">
                <a-button @click="handlerCleanFilter">
                    <fa-icon :icon="['fas', 'broom-wide']" />
                </a-button>
                <a-button type="primary" @click="handlerFilter">
                    <fa-icon :icon="['far', 'magnifying-glass-plus']" class="mr-2" /> Nueva busqueda
                </a-button>
            </div>
        </div>
        <ul class="details">
            <li class="detail-card" v-for="(item, index) in details" :key="index">
                <fa-icon :icon="['fas', item.icon]" />
                <div class="stats">
                    <apexchart
                        :ref="item.ref"
                        type="area"
                        width="100%"
                        height="50px"
                        :options="detailsOptions"
                        :series="item.series"
                    />
                </div>
                <p>{{ item.title }}</p>
                <h2>{{ formatCurrency(item.value) }}</h2>
            </li>
        </ul>
        <section class="sells">
            <div class="sells-header">
                <h1>Ventas Totales</h1>
                <ul v-if="false" class="periods">
                    <li>
                        <tag />
                    </li>
                </ul>
                <a-button type="primary" @click="handlerFilter">
                    <fa-icon :icon="['fas', 'square-plus']" class="mr-2" /> Añadir periodo
                </a-button>
            </div>
            <div class="sells-content">
                <apexchart type="line" width="100%" :height="600" :options="sellsOptions" :series="sellsSeries" />
            </div>
        </section>
        <section class="extras">
            <h1>Los más vendidos</h1>
            <div class="donut">
                <apexchart
                    ref="top_seller_pie"
                    type="donut"
                    width="100%"
                    :height="100"
                    :options="topSellerOptions"
                    :series="topSellerSeries"
                />
            </div>
            <div class="popular">
                <h3>producto estrella</h3>
                <h4>
                    {{
                        topSellerOptions.labels.reduce(
                            (max, item) => (item.quantity > max.quantity ? item : max),
                            topSellerOptions.labels[0]
                        )
                    }}
                </h4>
                <fa-icon :icon="['fas', 'star']" />
            </div>
            <div class="top">
                <div class="top-header">
                    <h3>top 3</h3>
                </div>
                <ul>
                    <template v-for="(item, idx) in topSalesData">
                        <li v-if="item.top">
                            <span>
                                {{ item.product }}
                            </span>
                            <span class="percentage">
                                <div>
                                    <span> {{ item.percentage }}% </span>
                                    <span> Ventas </span>
                                </div>
                                <div>
                                    <div
                                        :style="{
                                            backgroundColor: colors[idx],
                                        }"
                                    ></div>
                                    <div
                                        :style="{
                                            width: `${item.percentage}%`,
                                            backgroundColor: colors[idx],
                                        }"
                                    ></div>
                                </div>
                            </span>
                            <!-- <span>
                            {{ formatCurrency(item.value) }}
                        </span> -->
                        </li>
                    </template>
                </ul>
            </div>
        </section>
    </div>
</template>

<script>
import Actions from './_actions'
import Variables from './_variables'
import Checkbox from '@/application/components/checkbox.vue'
import Tag from '@/application/components/tag.vue'
import YearSelect from '@/application/components/year-select.vue'
import Apexchart from 'vue-apexcharts'
import Pricing from '@/application/mixins/pricing.js'

export default {
    mixins: [Actions, Pricing],
    components: { Checkbox, Tag, YearSelect, Apexchart },
    data() {
        return Variables()
    },
    async mounted() {
        // await this.getData()
    },
}
</script>

<style scoped lang="scss">
@import './styles.scss';
</style>
